import React, { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import APP_ROUTES from "src/routes/routes";
import LoadingWrapper from "src/components/Common/Table/Loading";
import useGetTestPackageDetail from "src/components/TestPackage/detail/useGetTestPackageDetail";
import TestPackageDetailForm from "src/components/TestPackage/form/TestPackageDetailForm";
import routeGuard from "src/Hooks/routeGuard";
import { FILE_HISTORY_TYPES, PAGINATION_DEFAULT, RESOURCE_TYPE } from "src/constant/common";
import useGetFilesHistoryTestPackageDetail from "src/components/TestPackage/detail/useGetFilesHistory";

export const FORM_NAME = {
  MAIN: {
    ID: "user_input_id",
    TITLE: "title",
    INSTANCE_ID: "project_instance_id",
    INSTANCE_NAME: "project_instance_name",
    LINKED_INSTANCE: "combination_id",
    USED_GREENGRASS_IMAGE: "used_greengrass_image",
    LAST_EDITOR: "updated_by",
    PLAN_START_DATE: "plan_start_date",
    INCREMENT_ID: "increment_id",
    NAME: "name",
  },
  FILES_HISTORY: {
    NAME: "s3_key",
    TYPE: "file_type",
    SOURCE: "source",
    CHANGED_BY: "name",
    UPDATED_AT: "updated_at",
  },
  SEQUENCE_FILE_HISTORY: {},
  DEPLOYMENT_HISTORY: {},
};

const TestPackageDetail = () => {
  const { id } = useParams();
  let [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const filesHistoryPage = searchParams.get("filesHistoryPage");
  const condition = searchParams.get("condition");
  const instanceId = searchParams.get("instanceId");

  const { data, isLoading: isLoadingPackageDetail } = useGetTestPackageDetail(id);
  const { data: fileHistories, isFetching: isFetchingFileHistories } = useGetFilesHistoryTestPackageDetail({
    filesHistoryPage,
    limit: PAGINATION_DEFAULT.smallPageSize,
    test_package_id: id,
    type: FILE_HISTORY_TYPES.DEPLOYMENT,
  });

  const getRedirectURL = useCallback(
    (pageIndex) => {
      const baseUrl = `${APP_ROUTES.TEST_PACKAGE}?id=${id}`;
      const queryParams = [
        (page || pageIndex) && `page=${page || pageIndex}`,
        condition && `condition=${condition}`,
        instanceId && `instanceId=${instanceId}`,
      ].filter(Boolean); // loại bỏ undefined/false

      return queryParams.length ? `${baseUrl}&${queryParams.join("&")}` : baseUrl;
    },
    [id, page, condition, instanceId]
  );

  return (
    <>
      <LoadingWrapper loading={isLoadingPackageDetail} customClass="loading-detail-page">
        <TestPackageDetailForm
          data={data}
          fileHistories={fileHistories}
          isFetchingFileHistories={isFetchingFileHistories}
          getRedirectURL={getRedirectURL}
        />
      </LoadingWrapper>
    </>
  );
};

export default routeGuard(TestPackageDetail, RESOURCE_TYPE.PROJECT_INSTANCE);
